import {Box, Heading, Table, Tbody, Td, Text, Th, Thead, Tr, useMediaQuery} from "@chakra-ui/react";
import {PaginationRow, StyledButton} from "../../../../components";
import {referalData} from "../../../../helpers/data-jsons";
import {useState} from "react";


export const Withdraw = () => {
    const [isSmallerThan1250] = useMediaQuery("(max-width: 1250px)")
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(7);

    const totalPages = Math.ceil(referalData.length / itemsPerPage);
    const currentItems = referalData.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);


    return (
        <Box
            borderRadius={'16px'}
            bg={'neutral.1100'}
            overflowY="auto"
            p={'48px 32px 32px 32px'}>
            <Heading fontSize={'heading.3xl'} mb={'24px'}>Withdraw</Heading>
            <Table
                variant='unstyled'>
                <Thead>
                    <Tr
                        fontSize={'body.sm'}
                        borderRadius={'8px'}
                        bg={'neutral.900'}>
                        <Th>Date/Time</Th>
                        <Th>Price</Th>
                        <Th>Pair</Th>
                        <Th>Type</Th>
                        <Th>Total Price</Th>
                        <Th>Amount</Th>
                        <Th>Excuted</Th>
                        <Th>Status</Th>
                    </Tr>
                </Thead>
                <Tbody
                    overflowY={isSmallerThan1250 ? 'scroll' : 'unset'}>
                    {currentItems.map((item) => (
                        <Tr
                            key={item.id}
                            bg={item.status === 'Cancelled' ? 'neutral.900':'neutral.1100'}
                            h={'76px'}
                            w={'full'}>
                            <Td>{item.date}</Td>
                            <Td>{item.price}</Td>
                            <Td>
                                <Text fontSize={'body.lg'}>{item.pair}</Text>
                                <Text color={'neutral.500'} fontSize={'body.xs'}>{item.pair_type}</Text>
                            </Td>
                            <Td color={item.type === 'Buy' ? '#2FA766' : '#E2464A'}>{item.type}</Td>
                            <Td>{item.total_price}</Td>
                            <Td>{item.amount}</Td>
                            <Td>{item.executed}</Td>
                            <Td>
                                <StyledButton
                                    _hover={''}
                                    w={'76px'}
                                    fontSize={'body.xs'}
                                    bg={item.status === 'Completed' ? 'success.300' : 'error.300'}>
                                    {item.status}
                                </StyledButton>
                            </Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>
            <PaginationRow
                pageCount={totalPages}
                onPageChange={setCurrentPage}
                itemsPerPage={itemsPerPage}
                onItemsPerPageChange={(newCount) => {
                    setItemsPerPage(newCount);
                    setCurrentPage(0);
                }}
            />
        </Box>
    )
}